import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentsToggleSummaryComponent } from './documents-toggle-summary.component';
import { IconButtonModule } from '../../directives/icon-button/icon-button.module';

@NgModule({
  declarations: [DocumentsToggleSummaryComponent],
  exports: [
    DocumentsToggleSummaryComponent
  ],
  imports: [
    CommonModule,
    IconButtonModule
  ]
})
export class DocumentsToggleSummaryModule { }
